import { Button, Divider, Form, Switch, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import Sticky from 'react-sticky-el';
import parse from 'html-react-parser';
import GlobalService from '../../../../services/Global.service';
import moment from 'moment';
import classNames from 'classnames';
import EmptyCustom from '../../../../assets/Images/icons/emptyCustom';
import TableCookie from './TableCookie';
import ModalConfirm from '../../../../components/Shared/modal/confirm';

const StepPreview = ({ forms, ...props }) => {
    const { t, i18n } = useTranslation(['translation', 'consent']);

    const [previewLang, setPreviewLang] = useState('TH');
    const [logo, setLogo] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);

    const {
        cookiePolicy,
        cookieIntroductionLawfulBasis,
        cookieAreUsed,
        cookiePreferences,
        cookiePolicyChange,
    } = forms;

    const _cookiePolicy = cookiePolicy.getFieldsValue();
    const _cookieIntroductionLawfulBasis =
        cookieIntroductionLawfulBasis.getFieldsValue();
    const _cookieAreUsed = cookieAreUsed.getFieldsValue();
    const _cookiePreferences = cookiePreferences.getFieldsValue();
    const _cookiePolicyChange = cookiePolicyChange.getFieldsValue();

    // Cheked

    const cookieIntroductionIsDisplay = Form.useWatch(
        'cookieIntroductionIsDisplay',
        cookieIntroductionLawfulBasis
    );
    const cookieWhatAreIsDisplay = Form.useWatch(
        'cookieWhatAreIsDisplay',
        cookieIntroductionLawfulBasis
    );
    const cookieBenefitIsDisplay = Form.useWatch(
        'cookieBenefitIsDisplay',
        cookieIntroductionLawfulBasis
    );
    const cookieHowDoIsDisplay = Form.useWatch(
        'cookieHowDoIsDisplay',
        cookieAreUsed
    );
    const cookieWhatTypeIsDisplay = Form.useWatch(
        'cookieWhatTypeIsDisplay',
        cookieAreUsed
    );
    const cookieSettingIsDisplay = Form.useWatch(
        'cookieSettingIsDisplay',
        cookiePreferences
    );
    const cookieThirdPartyIsDisplay = Form.useWatch(
        'cookieThirdPartyIsDisplay',
        cookiePreferences
    );
    const cookieChangeIsDisplay = Form.useWatch(
        'cookieChangeIsDisplay',
        cookiePolicyChange
    );
    const cookieDataControllerIsDisplay = Form.useWatch(
        'cookieDataControllerIsDisplay',
        cookiePolicyChange
    );
    const cookieDataProtectionIsDisplay = Form.useWatch(
        'cookieDataProtectionIsDisplay',
        cookiePolicyChange
    );

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImage(
                    _cookiePolicy?.cookieCompanyLogoId
                );
                if (data.resultData?.imageId) {
                    setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (_cookiePolicy?.cookieCompanyLogoId) getImage();
        else setLogo(null);
    }, [_cookiePolicy?.cookieCompanyLogoId]);

    const allCheck = (category) => {
        let check = category?.filter((res) => res?.isEnable);
        return check?.length;
    };

    const getNextVersion = () => {
        let item = '';
        let version = props?.previewData?.cookiePolicy?.latestPublishVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };

    const statusSwitch = (isPublished, isPublishedVersion) => {
        return (
            <div className="flex items-center space-x-2 mt-1">
                <div
                    className={classNames(
                        'rounded-full w-max px-3 text-xs font-medium',
                        {
                            'text-[#9A9A9A]': !isPublished,
                            'text-[#4ACE8F]': isPublished,
                        }
                    )}
                    style={
                        isPublished
                            ? {
                                  border: '1px solid #4ACE8F',
                              }
                            : {
                                  border: '1px solid #9A9A9A',
                              }
                    }
                >
                    {isPublished ? 'Published' : 'Draft'} {isPublishedVersion}
                </div>
                <span className="text-[#65707A]">
                    {isPublished &&
                        `${t('Last published', { ns: 'consent' })} : ` +
                            `${
                                props?.previewData?.cookiePolicy
                                    ?.publishDate !== undefined
                                    ? props?.previewData?.cookiePolicy
                                          ?.publishDate
                                    : '-'
                            }`}
                </span>
            </div>
        );
    };

    let cookiePolicyDataSubjectType = [];

    const dsTypeGroup = _cookiePolicy?.cookiePolicyDataSubjectType;

    if (dsTypeGroup) {
        const dsTypefilter = props?.dsType.filter((ds) =>
            dsTypeGroup.includes(ds.id)
        );
        cookiePolicyDataSubjectType = dsTypefilter.map((ds) => {
            return {
                dataSubjectId: ds.id,
                dataSubjectNameTh: ds.nameEn,
                dataSubjectNameEn: ds.nameTh,
            };
        });
    }

    const findDomain = props?.domainList.find(
        (domain) => _cookiePolicy?.domainId === domain.domainId
    );
    const domainName = findDomain ? findDomain.domainName : '-';

    let isChange = false;
    let isPublished = false;
    const version = props?.previewData?.cookiePolicy?.version || '0000.0';
    let isPublishedVersion = version;
    const parts = version?.split('.');

    const numberBehindDecimal = parseInt(parts[1]);
    const numberVersion = parseInt(parts[0]);
    if (parts && parts.length > 0) {
        if (numberVersion > 0) {
            isPublished = true;
            isPublishedVersion = parts[0] + '.0';
            if (numberBehindDecimal > 0) {
                isChange = true;
                isPublishedVersion = parts[0] + '.0';
            }
        }
    }

    return (
        <Form name="preview">
            <Sticky stickyClassName="bg-white p-4 w-full z-50">
                <div className="flex px-4">
                    <div className="flex-1">
                        <div className="text-2xl font-semibold">
                            {t('policy.des8')}
                        </div>
                        {statusSwitch(isPublished, isPublishedVersion)}
                    </div>
                    <div className="flex space-x-4">
                        {isChange && (
                            <div className="text-xs text-right text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${
                                            props?.previewData?.cookiePolicy
                                                ?.updateDate || '-'
                                        }`}
                                </div>
                                <div>{`${t('Version')} : ${version}`}</div>
                                <div className="text-[#F0536F]">
                                    <span className="text-xl align-middle">
                                        &bull;
                                    </span>{' '}
                                    {t('Consent.DataChanged')}
                                </div>
                            </div>
                        )}
                        {((numberVersion === 0 && numberBehindDecimal > 0) ||
                            (numberVersion > 0 &&
                                numberBehindDecimal === 0)) && (
                            <div className="text-xs mt-[9px] text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${
                                            props?.previewData?.cookiePolicy
                                                ?.updateDate || '-'
                                        }`}
                                </div>
                            </div>
                        )}
                        <Button
                            type="default"
                            size="large"
                            onClick={props.saveDraft}
                            className="border-purple text-purple px-6"
                        >
                            {t('Save Draft')}
                        </Button>
                        <Button
                            loading={props.loading_}
                            type="primary"
                            size="large"
                            onClick={() => {
                                setOpenConfirm(true);
                            }}
                        >
                            {t('Save And Publish')}
                        </Button>
                    </div>
                </div>
            </Sticky>

            <div className="px-4">
                <Divider className="mb-1" />
                <div className={`py-4 flex space-x-2 text-tiny`}>
                    <span
                        style={{ borderRight: '1px solid #DBDBDB' }}
                        onClick={() => {
                            setPreviewLang('TH');
                        }}
                        className={`${
                            previewLang === 'TH'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80 pr-2`}
                    >
                        {t('policy.th')}
                    </span>
                    <span
                        onClick={() => {
                            setPreviewLang('EN');
                        }}
                        className={`${
                            previewLang === 'EN'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80`}
                    >
                        {t('policy.en')}
                    </span>
                </div>
                <div className=" space-y-4">
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Define the policy name and organization information'
                                    : 'กำหนดชื่อนโยบายและข้อมูลองค์กร'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(1);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Name of Cookies Policy'
                                    : 'ชื่อนโยบายคุกกี้'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'EN'
                                    ? _cookiePolicy?.cookiePolicyNameEn || '-'
                                    : _cookiePolicy?.cookiePolicyNameTh || '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Updated as of'
                                    : 'ฉบับ ณ วันที่'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_cookiePolicy?.cookieEffectiveDate
                                    ? moment(
                                          _cookiePolicy?.cookieEffectiveDate
                                      ).format('DD/MM/YYYY')
                                    : '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Organization name (or Owner Name)'
                                    : 'ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'EN'
                                    ? _cookiePolicy?.cookieCompanyNameEn || '-'
                                    : _cookiePolicy?.cookieCompanyNameTh || '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN' ? 'Domain Name' : 'โดเมน'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {domainName}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Company Logo'
                                    : 'โลโก้องค์กร'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {logo ? (
                                    // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                    <img
                                        className="w-auto h-16 rounded-lg object-cover"
                                        style={{
                                            border: '1px solid #DBDBDB',
                                        }}
                                        src={logo}
                                        alt="image"
                                    />
                                ) : (
                                    svgNoImage
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'What types of data subjects does this policy apply to'
                                    : 'นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {cookiePolicyDataSubjectType
                                    ?.map((ds) =>
                                        previewLang === 'EN'
                                            ? ds.dataSubjectNameEn
                                            : ds.dataSubjectNameTh
                                    )
                                    .join(', ') || '-'}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Introduction and Lawful Basis'
                                    : 'ความหมายของคุกกี้'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(2);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cookieIntroductionLawfulBasis?.cookieIntroductionTitleEn ||
                                          '-'
                                        : _cookieIntroductionLawfulBasis?.cookieIntroductionTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cookieIntroductionIsDisplay}
                                        onChange={(checked) => {
                                            cookieIntroductionLawfulBasis.setFieldValue(
                                                'cookieIntroductionIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cookieIntroductionLawfulBasis?.cookieIntroductionContentEn ||
                                              '-'
                                            : _cookieIntroductionLawfulBasis?.cookieIntroductionContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />

                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cookieIntroductionLawfulBasis?.cookieWhatAreTitleEn ||
                                          '-'
                                        : _cookieIntroductionLawfulBasis?.cookieWhatAreTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cookieWhatAreIsDisplay}
                                        onChange={(checked) => {
                                            cookieIntroductionLawfulBasis.setFieldValue(
                                                'cookieWhatAreIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cookieIntroductionLawfulBasis?.cookieWhatAreContentEn ||
                                              '-'
                                            : _cookieIntroductionLawfulBasis?.cookieWhatAreContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />

                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cookieIntroductionLawfulBasis?.cookieBenefitTitleEn ||
                                          '-'
                                        : _cookieIntroductionLawfulBasis?.cookieBenefitTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cookieBenefitIsDisplay}
                                        onChange={(checked) => {
                                            cookieIntroductionLawfulBasis.setFieldValue(
                                                'cookieBenefitIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cookieIntroductionLawfulBasis?.cookieBenefitContentEn ||
                                              '-'
                                            : _cookieIntroductionLawfulBasis?.cookieBenefitContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'How do we use cookies and what cookies are used ?'
                                : 'เราใช้คุกกี้อย่างไรและใช้คุกกี้อะไรบ้าง'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(3);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookieAreUsed?.cookieHowDoTitleEn || '-'
                                    : _cookieAreUsed?.cookieHowDoTitleTh || '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieHowDoIsDisplay}
                                    onChange={(checked) => {
                                        cookieAreUsed.setFieldValue(
                                            'cookieHowDoIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookieAreUsed?.cookieHowDoContentEn ||
                                          '-'
                                        : _cookieAreUsed?.cookieHowDoContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                        <Divider dashed className="border-t-2" />

                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookieAreUsed?.cookieWhatTypeTitleEn ||
                                      '-'
                                    : _cookieAreUsed?.cookieWhatTypeTitleTh ||
                                      '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieWhatTypeIsDisplay}
                                    onChange={(checked) => {
                                        cookieAreUsed.setFieldValue(
                                            'cookieWhatTypeIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="w-[85%]">
                            {props?.domainId ? (
                                <>
                                    {props?.cookieList &&
                                    allCheck(
                                        props?.cookieList?.cookieCategoryList
                                    ) ? (
                                        <>
                                            {props?.cookieList?.cookieCategoryList?.map(
                                                (val) => (
                                                    <div
                                                        hidden={!val?.isEnable}
                                                        className="mb-3"
                                                    >
                                                        <p className="text-[#65707A] font-semibold">
                                                            •{' '}
                                                            {previewLang ===
                                                            'TH'
                                                                ? val?.cookieCategoryNameTh
                                                                : val?.cookieCategoryNameEn}
                                                        </p>
                                                        <p className="text-[#65707A]">
                                                            {previewLang ===
                                                            'TH'
                                                                ? val?.descriptionTh
                                                                : val?.descriptionEn}
                                                        </p>
                                                        <TableCookie
                                                            lang={previewLang}
                                                            listCookie={
                                                                val?.cookieList ||
                                                                []
                                                            }
                                                        />
                                                    </div>
                                                )
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <EmptyCustom
                                                text={
                                                    i18n.language === 'en'
                                                        ? `ไม่สามารถแสดงข้อมูลได้ เนื่องจากโดเมนนี้ปิดการแสดงประเภทคุกกี้อยู่<br>คุณสามารถเปิดการแสดงประเภทคุกกี้ได้ที่เมนู Cookie Management > Cookie Category`
                                                        : `ไม่สามารถแสดงข้อมูลได้ เนื่องจากโดเมนนี้ปิดการแสดงประเภทคุกกี้อยู่<br>คุณสามารถเปิดการแสดงประเภทคุกกี้ได้ที่เมนู Cookie Management > Cookie Category`
                                                }
                                            />
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <EmptyCustom
                                        text={
                                            i18n.language === 'en'
                                                ? `Please specify the domain at step 1 : Define the policy name and organization information.`
                                                : `กรุณาระบุโดเมนที่ขั้นตอนที่ 1 : กำหนดชื่อนโยบายและข้อมูลองค์กร`
                                        }
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Cookies Preferences'
                                : 'การกำหนดการทำงานของคุกกี้'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(4);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookiePreferences?.cookieSettingTitleEn ||
                                      '-'
                                    : _cookiePreferences?.cookieSettingTitleTh ||
                                      '-'}
                            </div>

                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieSettingIsDisplay}
                                    onChange={(checked) => {
                                        cookiePreferences.setFieldValue(
                                            'cookieSettingIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookiePreferences?.cookieSettingContentEn ||
                                          '-'
                                        : _cookiePreferences?.cookieSettingContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookiePreferences?.cookieThirdPartyTitleEn ||
                                      '-'
                                    : _cookiePreferences?.cookieThirdPartyTitleTh ||
                                      '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieThirdPartyIsDisplay}
                                    onChange={(checked) => {
                                        cookiePreferences.setFieldValue(
                                            'cookieThirdPartyIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookiePreferences?.cookieThirdPartyContentEn ||
                                          '-'
                                        : _cookiePreferences?.cookieThirdPartyContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>

                <div className="mt-2">
                    <div
                        className="flex px-4 py-1 items-center mb-4"
                        style={{ background: '#F4F6FC' }}
                    >
                        <div className="flex-1 text-purple-PHX font-semibold">
                            {previewLang === 'EN'
                                ? 'Policy change and contact channels'
                                : 'การเปลี่ยนแปลงนโยบาย และช่องทางการติดต่อ'}
                        </div>
                        <div
                            className="mt-1 hover:opacity-80 cursor-pointer"
                            onClick={() => {
                                props.goToStep(5);
                            }}
                        >
                            {EditIcon}
                        </div>
                    </div>
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookiePolicyChange?.cookieChangeTitleEn ||
                                      '-'
                                    : _cookiePolicyChange?.cookieChangeTitleTh ||
                                      '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieChangeIsDisplay}
                                    onChange={(checked) => {
                                        cookiePolicyChange.setFieldValue(
                                            'cookieChangeIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookiePolicyChange?.cookieChangeContentEn ||
                                          '-'
                                        : _cookiePolicyChange?.cookieChangeContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                    <Divider dashed className="border-t-2" />
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookiePolicyChange?.cookieDataControllerTitleEn ||
                                      '-'
                                    : _cookiePolicyChange?.cookieDataControllerTitleTh ||
                                      '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieDataControllerIsDisplay}
                                    onChange={(checked) => {
                                        cookiePolicyChange.setFieldValue(
                                            'cookieDataControllerIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A]">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookiePolicyChange?.cookieDataControllerContentEn ||
                                          '-'
                                        : _cookiePolicyChange?.cookieDataControllerContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                    <Divider dashed className="border-t-2" />
                    <div className="text-sm space-y-2">
                        <div className="font-semibold text-[#171717] flex">
                            <div className="w-full">
                                {previewLang === 'EN'
                                    ? _cookiePolicyChange?.cookieDataProtectionTitleEn ||
                                      '-'
                                    : _cookiePolicyChange?.cookieDataProtectionTitleTh ||
                                      '-'}
                            </div>
                            <div className="flex items-center space-x-2 flex-shrink-0">
                                <div className="font-semibold">
                                    {previewLang === 'EN'
                                        ? 'Show'
                                        : 'แสดงข้อมูล'}
                                </div>
                                <Switch
                                    checked={cookieDataProtectionIsDisplay}
                                    onChange={(checked) => {
                                        cookiePolicyChange.setFieldValue(
                                            'cookieDataProtectionIsDisplay',
                                            checked
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="whitespace-pre-wrap text-[#65707A] w-full">
                            {parse(
                                `${
                                    previewLang === 'EN'
                                        ? _cookiePolicyChange?.cookieDataProtectionContentEn ||
                                          '-'
                                        : _cookiePolicyChange?.cookieDataProtectionContentTh ||
                                          '-'
                                }`
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={props.loading_}
                handelOk={() => {
                    props?.onFormFinish('', {
                        values: props?.form?.getFieldsValue(),
                    });
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {props?.previewData?.cookiePolicy
                                ?.latestPublishVersion
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
        </Form>
    );
};

export default StepPreview;

const EditIcon = (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
            fill="#7B67FB"
        />
        <path
            d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
            fill="#7B67FB"
        />
    </svg>
);

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
